import { configureStore } from '@reduxjs/toolkit'

import leaderBoardReducer from '../features/LeaderBoard/leaderBoardSlice'

export const store = configureStore({
    reducer: {
        leaderBoard: leaderBoardReducer,
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
